import { SET_DATADICT_LOCATION_LABELS } from '../constants/ActionTypes.js';

//////
export const setDatadictLocationLabels = data => ({
  type: SET_DATADICT_LOCATION_LABELS,
  data,
});
